import { useState, useEffect } from 'react';
import {
    addFavorite,
    deleteFavorite
} from '../services/FavoriteService';

export const useFavorite = () => {

    const [loading, setLoading] = useState(false);
    const [error, setError] = useState(null);

    const addFavoriteProduct = async (product) => {
        try {
            return await addFavorite(product);
        } catch {
            setError('Failed to add product');
        }
    };

    const removeFavoriteProduct = async (id) => {
        try {
            return await deleteFavorite(id);
        } catch {
            setError('Failed to delete product');
        }
    };

    return { removeFavoriteProduct, addFavoriteProduct, loading, error, };

};
